/**
 * @generated SignedSource<<09f5b8a1498a8df945aa6c7062502786>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceScaffoldWorkspaceFragment$data = {
  readonly id: string;
  readonly latest: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"WorkspaceScaffoldVersionFragment">;
      };
    }>;
  };
  readonly name: string | null | undefined;
  readonly owner: {
    readonly username: string;
    readonly " $fragmentSpreads": FragmentRefs<"EntityProfilePicFragment">;
  };
  readonly private: boolean;
  readonly slug: string;
  readonly submissions: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
    }>;
  };
  readonly viewerCanCreateVersion: boolean;
  readonly viewerCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"VoteDisplayFragment" | "WorkspacePublishButtonFragment" | "WorkspaceVersionHistoryFragment">;
  readonly " $fragmentType": "WorkspaceScaffoldWorkspaceFragment";
};
export type WorkspaceScaffoldWorkspaceFragment$key = {
  readonly " $data"?: WorkspaceScaffoldWorkspaceFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceScaffoldWorkspaceFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "latest"
        ]
      }
    ]
  },
  "name": "WorkspaceScaffoldWorkspaceFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "private",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "username",
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "thumbnail",
              "value": true
            }
          ],
          "kind": "FragmentSpread",
          "name": "EntityProfilePicFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "latest",
      "args": null,
      "concreteType": "WorkspaceVersionConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceScaffoldWorkspaceFragment_latest_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WorkspaceVersionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "WorkspaceVersion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "WorkspaceScaffoldVersionFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v0/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "viewerCanEdit",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "UPDATE_WORKSPACE"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"UPDATE_WORKSPACE\")"
    },
    {
      "alias": "viewerCanCreateVersion",
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "CREATE_WORKSPACE_VERSION"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerCan",
      "storageKey": "viewerCan(action:\"CREATE_WORKSPACE_VERSION\")"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "SubmissionConnection",
      "kind": "LinkedField",
      "name": "submissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SubmissionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            (v0/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": "submissions(first:1)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteDisplayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspaceVersionHistoryFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WorkspacePublishButtonFragment"
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};
})();

(node as any).hash = "5609c565cfcbb8e5e848e80ebc66d6e6";

export default node;
